import React, { useState, useEffect } from 'react';
import { NavLink, useParams} from 'react-router-dom';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import apiService from './../../Auth/apiService.jsx';
import { useAuth } from './../../Auth/AuthContext.jsx';
import { Card, CardBody, CardHeader } from 'react-bootstrap';
import { useForm } from 'react-hook-form';

export default function GenerarDxAnual(){
    const { id } = useParams();
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [swalProps, setSwalProps] = useState();
    const { handleSubmit, register, setValue, getValues, watch, formState: { errors }} = useForm({
        defaultValues: {
            id: id || '0',
            fechas: {prevStart: '', prevEnd: '', currStart: '', currEnd: '',},
            fechaMesActual: '',
            datosPaginaTres: {},
            datosPaginaCuatro: {},
            datosPaginaCinco: {},
            datosPaginaSeis: {},
            datosPaginaSiete: {},
            datosPaginaOcho: {},
            datosPaginaNueve: {},
            datosPaginaDiez: {},
            datosPaginaOnce: {},
            datosPaginaDoce: {},
            datosPaginaTrece: {},
            datosPaginaCatorce: {},
            datosPaginaQuince: {},
            datosPaginaDieciseis: {},
            datosPaginaDiecisiete: {},
            datosPaginaDieciocho: {},
            datosPaginaDiecinueve: {}
        }
    });
    const [prevStart, setPrevStart] = useState('');
    const [prevEnd, setPrevEnd] = useState('');
    const [currStart, setCurrStart] = useState('');
    const [currEnd, setCurrEnd] = useState('');

    // Initialize sensible default date ranges:
    useEffect(() => {
        // helper to format yyyy-mm-dd
        const fmt = (d) => d.toISOString().slice(0,10);

        const today = new Date();
        // Current period: first day to last day of previous month
        const currStartDate = new Date(today.getFullYear(), 0, 1);
        const currEndDate = new Date(today.getFullYear(), today.getMonth(), 0);

        // Previous period: first day to last day of the month before previous
        const prevStartDate = new Date(today.getFullYear()-1, 0, 1);
        const prevEndDate = new Date(today.getFullYear()-1, today.getMonth(), 0);

        // Only set defaults if not already set by user
        setPrevStart((v) => v || fmt(prevStartDate));
        setPrevEnd((v) => v || fmt(prevEndDate));
        setCurrStart((v) => v || fmt(currStartDate));
        setCurrEnd((v) => v || fmt(currEndDate));
    }, []);

    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    async function fetchReporteAnual(prevStart, prevEnd, currStart, currEnd) {
        setCargando(true);
        if (!prevStart || !prevEnd || !currStart || !currEnd) {
            Mensaje('Fechas incompletas', 'Por favor complete las cuatro fechas antes de generar el reporte.');
            return;
        }
        const url = '/diagnostico/reportes/generarreporteanual'; 
        await apiService.post(url, {
                prevStart,
                prevEnd,
                currStart,
                currEnd
            }, token)
        .then((response) => {
            const result = response.data;
            setValue('fechaMesActual', result.fechaMesActual || '');
            setValue('datosPaginaTres', result.datosPaginaTres || {});
            setValue('datosPaginaCuatro', result.datosPaginaCuatro || {});
            setValue('datosPaginaCinco', result.datosPaginaCinco || {});
            setValue('datosPaginaSeis', result.datosPaginaSeis || {});
            setValue('datosPaginaSiete', result.datosPaginaSiete || {});
            setValue('datosPaginaOcho', result.datosPaginaOcho || {});
            setValue('datosPaginaNueve', result.datosPaginaNueve || {});
            setValue('datosPaginaDiez', result.datosPaginaDiez || {});
            setValue('datosPaginaOnce', result.datosPaginaOnce || {});
            setValue('datosPaginaDoce', result.datosPaginaDoce || {});
            setValue('datosPaginaTrece', result.datosPaginaTrece || {});
            setValue('datosPaginaCatorce', result.datosPaginaCatorce || {});
            setValue('datosPaginaQuince', result.datosPaginaQuince || {});
            setValue('datosPaginaDieciseis', result.datosPaginaDieciseis || {});
            setValue('datosPaginaDiecisiete', result.datosPaginaDiecisiete || {});
            setValue('datosPaginaDieciocho', result.datosPaginaDieciocho || {});
            setValue('datosPaginaDiecinueve', result.datosPaginaDiecinueve || {});
        })
        .catch((error) => {
            console.error('Error fetching annual report:', error);
            Mensaje('Error', 'Hubo un error al generar el reporte anual.');
        })
        .finally(() => {
            setCargando(false);
        });
    }

    useEffect(() => {
          async function fetchReporte(id) {
              if (id !== '0') {
                  setCargando(true);
                  await apiService.get('/diagnostico/reporteanual/obtenerreporte/' + id, token)
                  .then((response) => {
                      if (response.status === 200) {
                          const result = response.data;
                          setValue('fechaMesActual', result.fechaMesActual || '');
                          setValue('datosPaginaTres', result.datosPaginaTres || {});
                          setValue('datosPaginaCuatro', result.datosPaginaCuatro || {});
                          setValue('datosPaginaCinco', result.datosPaginaCinco || {});
                          setValue('datosPaginaSeis', result.datosPaginaSeis || {});
                          setValue('datosPaginaSiete', result.datosPaginaSiete || {});
                          setValue('datosPaginaOcho', result.datosPaginaOcho || {});
                          setValue('datosPaginaNueve', result.datosPaginaNueve || {});
                          setValue('datosPaginaDiez', result.datosPaginaDiez || {});
                          setValue('datosPaginaOnce', result.datosPaginaOnce || {});
                          setValue('datosPaginaDoce', result.datosPaginaDoce || {});
                          setValue('datosPaginaTrece', result.datosPaginaTrece || {});
                          setValue('datosPaginaCatorce', result.datosPaginaCatorce || {});
                          setValue('datosPaginaQuince', result.datosPaginaQuince || {});
                          setValue('datosPaginaDieciseis', result.datosPaginaDieciseis || {});
                          setValue('datosPaginaDiecisiete', result.datosPaginaDiecisiete || {});
                          setValue('datosPaginaDieciocho', result.datosPaginaDieciocho || {});
                          setValue('datosPaginaDiecinueve', result.datosPaginaDiecinueve || {});
                          setCargando(false);
                      } else {
                          Mensaje('Error', 'No se pudo obtener el reporte solicitado.');
                          setCargando(false);
                      }
                  })
                  .catch((error) => {
                      Mensaje('Error', 'No se pudo obtener el reporte solicitado.');
                      setCargando(false);
                  });
              }
          }
          fetchReporte(id);
      }, [id]);      
    
    const onSubmit = async (data) => {
        setCargando(true);
        const url = '/diagnostico/reportes/guardarreporteanual';
        data.fechas.currStart = currStart;
        data.fechas.currEnd = currEnd;
        data.fechas.prevStart = prevStart;
        data.fechas.prevEnd = prevEnd;
        await apiService.post(url, data, token)
        .then((response) => {
            Mensaje('Éxito', 'El reporte anual ha sido guardado correctamente.' + response.data.message + ' id:' + response.data.id);
        })
        .catch((error) => {
            console.error('Error saving annual report:', error);
            Mensaje('Error', 'Hubo un error al guardar el reporte anual.');
        })
        .finally(() => {
            setCargando(false);
        });
    };
    async function downloadToExcel(data, filename) {
      try {
        const XLSX = await import('xlsx');
        const rows = Array.isArray(data) ? data : [data];
        const ws = XLSX.utils.json_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Reporte');
        XLSX.writeFile(wb, filename);
      } catch (error) {
        console.error('Error downloading Excel:', error);
        Mensaje('Error', 'No se pudo descargar el archivo Excel.');
      }
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Generar reporte anual</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><NavLink to="/caracterizacion/reportes" > Reportes</NavLink></li>
                                <li className="breadcrumb-item active"> Generar reporte anual</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                    </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {id && id === '0' && <Card>
                        <CardHeader>
                            <h3 className="card-title">Generar reporte</h3>
                        </CardHeader>
                        <CardBody>
                            <div className="row">
                                <div className="col-md-6">
                                    <h5>Año anterior</h5>
                                    <div className="form-group">
                                        <label htmlFor='prevStart'>Fecha inicio</label>
                                        <input
                                            id='prevStart'
                                            type="date"
                                            className="form-control"
                                            value={prevStart}
                                            onChange={(e) => setPrevStart(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor='prevEnd'>Fecha fin</label>
                                        <input
                                            id='prevEnd'
                                            type="date"
                                            className="form-control"
                                            value={prevEnd}
                                            onChange={(e) => setPrevEnd(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <h5>&Uacute;ltimo año</h5>
                                    <div className="form-group">
                                        <label htmlFor='currStart'>Fecha inicio</label>
                                        <input
                                            id='currStart'
                                            type="date"
                                            className="form-control"
                                            value={currStart}
                                            onChange={(e) => setCurrStart(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor='currEnd'>Fecha fin</label>
                                        <input
                                            id="currEnd"
                                            type="date"
                                            className="form-control"
                                            value={currEnd}
                                            onChange={(e) => setCurrEnd(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div style={{ marginTop: 12 }}>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        fetchReporteAnual(prevStart, prevEnd, currStart, currEnd);
                                    }}
                                >
                                    Aplicar rangos
                                </button>
                            </div>
                        </CardBody>
                    </Card>}
                    <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                        <input type="hidden" {...register('id')} />
                        {getValues('fechaMesActual') && <Card>
                            <CardHeader className="d-flex justify-content-between align-items-center">
                                <h3 className="card-title">Datos pagina tres reporte</h3>
                                  <div style={{ marginBottom: 8 }}>
                                    <button 
                                    type="button" 
                                    className="btn btn-success"
                                    onClick={async () => { await downloadToExcel(watch('datosPaginaTres'), 'datosgenerales.xlsx')}}>Generar Excel</button>
                                  </div>
                            </CardHeader>
                            <CardBody>
                                {(() => {
                                    const d = watch('datosPaginaTres') || {};
                                    const toNum = (v) => {
                                      if (v === undefined || v === null || v === '') return NaN;
                                      const s = String(v).replace(/[^\d.-]/g, '');
                                      return s === '' ? NaN : Number(s);
                                    };

                                    // Monthly keys (existing)
                                    const hogaresNow = toNum(d.hogaresUltimoMes ?? d.hogaresUltimo_mes ?? d.hogaresUltimo ?? d.hogaresMesActual);
                                    const hogaresPrev = toNum(d.hogaresMesAnterior ?? d.hogares_mes_anterior ?? d.hogaresMesAnt ?? d.hogaresMesAnterior);
                                    const personasNow = toNum(d.personasUltimoMes ?? d.personasUltimo_mes ?? d.personasUltimo ?? d.personasMesActual);
                                    const personasPrev = toNum(d.personasMesAnterior ?? d.personas_mes_anterior ?? d.personasMesAnt ?? d.personasMesAnterior);

                                    // Annual keys (new) — tolerate several variants
                                    const hogaresYearNow = toNum(d.hogaresAnioActual ?? d.hogaresAnoActual ?? d.hogaresAnual ?? d.hogaresAnio ?? d.hogaresAnioActual);
                                    const hogaresYearPrev = toNum(d.hogaresAnioAnterior ?? d.hogaresAnoAnterior ?? d.hogaresAnioAnt ?? d.hogaresAnioAnterior);
                                    const personasYearNow = toNum(d.personasAnioActual ?? d.personasAnoActual ?? d.personasAnual ?? d.personasAnio);
                                    const personasYearPrev = toNum(d.personasAnioAnterior ?? d.personasAnoAnterior ?? d.personasAnioAnt ?? d.personasAnioAnterior);

                                    const pct = (a, b) => {
                                      if (Number.isNaN(a) || Number.isNaN(b) || b === 0) return '-';
                                      return (((a - b) / b * 100).toFixed(1) + '%');
                                    };

                                    const hasMonthly = !Number.isNaN(hogaresNow) || !Number.isNaN(personasNow) || !Number.isNaN(hogaresPrev) || !Number.isNaN(personasPrev);
                                    const hasAnnual = !Number.isNaN(hogaresYearNow) || !Number.isNaN(personasYearNow) || !Number.isNaN(hogaresYearPrev) || !Number.isNaN(personasYearPrev);

                                    return (
                                      <div>
                                        <div style={{ marginBottom: 12 }}>
                                          <strong>Resumen</strong>
                                        </div>

                                        {hasMonthly ? (
                                          <div style={{ marginBottom: 16 }}>
                                            <div style={{ marginBottom: 6 }}><strong>Resumen anual</strong></div>
                                            <div className="row">
                                              <div className="col-md-6">
                                                <h6>Hogares</h6>
                                                <ul className="list-unstyled">
                                                  <li>Último mes: {Number.isNaN(hogaresNow) ? '-' : hogaresNow.toLocaleString()}</li>
                                                  <li>Mes anterior: {Number.isNaN(hogaresPrev) ? '-' : hogaresPrev.toLocaleString()}</li>
                                                  <li>Cambio: {pct(hogaresNow, hogaresPrev)}</li>
                                                </ul>
                                              </div>

                                              <div className="col-md-6">
                                                <h6>Personas</h6>
                                                <ul className="list-unstyled">
                                                  <li>Último mes: {Number.isNaN(personasNow) ? '-' : personasNow.toLocaleString()}</li>
                                                  <li>Mes anterior: {Number.isNaN(personasPrev) ? '-' : personasPrev.toLocaleString()}</li>
                                                  <li>Cambio: {pct(personasNow, personasPrev)}</li>
                                                </ul>
                                              </div>
                                            </div>
                                          </div>
                                        ) : null}

                                        {hasAnnual ? (
                                          <div style={{ marginBottom: 8 }}>
                                            <div style={{ marginBottom: 6 }}><strong>Resumen anual</strong></div>
                                            <div className="row">
                                              <div className="col-md-6">
                                                <h6>Hogares (Año)</h6>
                                                <ul className="list-unstyled">
                                                  <li>Año actual: {Number.isNaN(hogaresYearNow) ? '-' : hogaresYearNow.toLocaleString()}</li>
                                                  <li>Año anterior: {Number.isNaN(hogaresYearPrev) ? '-' : hogaresYearPrev.toLocaleString()}</li>
                                                  <li>Cambio anual: {pct(hogaresYearNow, hogaresYearPrev)}</li>
                                                </ul>
                                              </div>

                                              <div className="col-md-6">
                                                <h6>Personas (Año)</h6>
                                                <ul className="list-unstyled">
                                                  <li>Año actual: {Number.isNaN(personasYearNow) ? '-' : personasYearNow.toLocaleString()}</li>
                                                  <li>Año anterior: {Number.isNaN(personasYearPrev) ? '-' : personasYearPrev.toLocaleString()}</li>
                                                  <li>Cambio anual: {pct(personasYearNow, personasYearPrev)}</li>
                                                </ul>
                                              </div>
                                            </div>
                                          </div>
                                        ) : null}

                                        {/* If neither monthly nor annual fields found, show raw data for debugging */}
                                        {!hasMonthly && !hasAnnual && Object.keys(d).length ? (
                                          <div style={{ marginTop: 12 }}>
                                            <strong>Datos recibidos (sin campos esperados):</strong>
                                            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{JSON.stringify(d, null, 2)}</pre>
                                          </div>
                                        ) : null}
                                      </div>
                                    );
                                })()}
                            </CardBody>
                        </Card>}
                        {getValues('fechaMesActual') && <Card style={{ marginTop: 20 }}>
                            <CardHeader>
                                <h3 className="card-title">Datos pagina cuatro reporte</h3>
                            </CardHeader>
                            <CardBody>
                                {(() => {
                                    const d = watch('datosPaginaCuatro') || {};

                                    // defensivas para localizar los dos arrays principales
                                    const leftRows = Array.isArray(d.leftSide.datos)
                                        ? d.leftSide.datos
                                        : [];

                                    const rightRows = Array.isArray(d.rightSide.datos)
                                        ? d.rightSide.datos
                                        : [];

                                    const toNum = (v) => {
                                        if (v === undefined || v === null || v === '') return 0;
                                        const s = String(v).replace(/[^\d.-]/g, '');
                                        return s === '' ? 0 : Number(s);
                                    };

                                    // Totales left
                                    const totalLeft = leftRows.reduce((acc, r) => {
                                        acc.hogaresUltimo += toNum(r.hogaresUltimoMes ?? r.hogaresUltimo ?? r.hogares_ultimo_mes);
                                        acc.hogaresAnterior += toNum(r.hogaresMesAnterior ?? r.hogaresMesAnt ?? r.hogares_mes_anterior);
                                        acc.personasUltimo += toNum(r.personasUltimoMes ?? r.personasUltimo ?? r.personas_ultimo_mes);
                                        acc.personasAnterior += toNum(r.personasMesAnterior ?? r.personasMesAnt ?? r.personas_mes_anterior);
                                        return acc;
                                    }, { hogaresUltimo: 0, hogaresAnterior: 0, personasUltimo: 0, personasAnterior: 0 });

                                    // Totales right
                                    const totalRight = rightRows.reduce((acc, r) => {
                                        acc.hogares += toNum(r.hogares ?? r.hogares_count ?? r.total_hogares);
                                        acc.personas += toNum(r.personas ?? r.total_personas ?? r.personas_count);
                                        return acc;
                                    }, { hogares: 0, personas: 0 });

                                    // sort right by hogares desc for readability
                                    const rightSorted = [...rightRows].sort((a, b) => toNum(b.hogares ?? b.hogares_count) - toNum(a.hogares ?? a.hogares_count));

                                    return (
                                        <div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                                            <div>
                                            <strong>Registros (left):</strong> {leftRows.length} &nbsp;&nbsp;
                                            <strong>Hogares último año:</strong> {totalLeft.hogaresUltimo.toLocaleString()} &nbsp;&nbsp;
                                            <strong>Personas último año:</strong> {totalLeft.personasUltimo.toLocaleString()}
                                            </div>
                                            <div>
                                            <strong>Registros (right):</strong> {rightRows.length} &nbsp;&nbsp;
                                            <strong>Hogares (right):</strong> {totalRight.hogares.toLocaleString()} &nbsp;&nbsp;
                                            <strong>Personas (right):</strong> {totalRight.personas.toLocaleString()}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-6">
                                              <h6>Por Subregión (último / anterior)</h6>
                                              <div style={{ marginBottom: 8 }}>
                                                <button 
                                                type="button" 
                                                className="btn btn-success"
                                                onClick={async () => { await downloadToExcel(leftRows, 'SubregionesAntioquia.xlsx')}}>A Excel</button>
                                              </div>
                                            
                                            {leftRows.length ? (
                                                <div style={{ overflowX: 'auto' }}>
                                                <table className="table table-sm table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ minWidth: 160 }}>Subregión</th>
                                                            <th style={{ minWidth: 100 }}>Año (Anterior)</th>
                                                            <th style={{ minWidth: 100 }}>Año (último)</th>
                                                            <th style={{ textAlign: 'right', minWidth: 110 }}>Hogares (últ)</th>
                                                            <th style={{ textAlign: 'right', minWidth: 110 }}>Hogares (ant)</th>
                                                            <th style={{ textAlign: 'right', minWidth: 110 }}>Δ Hogares</th>
                                                            <th style={{ textAlign: 'right', minWidth: 110 }}>Personas (últ)</th>
                                                            <th style={{ textAlign: 'right', minWidth: 110 }}>Personas (ant)</th>
                                                            <th style={{ textAlign: 'right', minWidth: 110 }}>Δ Personas</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {leftRows
                                                            .slice() // copy
                                                            .sort((a, b) => (toNum(b.hogaresUltimoMes ?? b.hogaresUltimo ?? b.hogares) - toNum(a.hogaresUltimoMes ?? a.hogaresUltimo ?? a.hogares)))
                                                            .map((r, i) => {
                                                            const subregion = r.subregion ?? r.sub_region ?? r.subreg ?? '-';
                                                            const mesAnt = r.mesAnterior ?? r.mesAnt ?? r.mes_anterior ?? '';
                                                            const mesUlt = r.ultimoMes ?? r.mesUltimo ?? r.ultimo_mes ?? '';
                                                            const hogaresUlt = toNum(r.hogaresUltimoMes ?? r.hogaresUltimo ?? r.hogares_ultimo_mes ?? r.hogares ?? 0);
                                                            const hogaresAnt = toNum(r.hogaresMesAnterior ?? r.hogaresMesAnt ?? r.hogares_mes_anterior ?? 0);
                                                            const personasUlt = toNum(r.personasUltimoMes ?? r.personasUltimo ?? r.personas_ultimo_mes ?? r.personas ?? 0);
                                                            const personasAnt = toNum(r.personasMesAnterior ?? r.personasMesAnt ?? r.personas_mes_anterior ?? 0);

                                                            const pct = (now, prev) => {
                                                                if (prev === 0) return prev === now ? '0%' : '-';
                                                                return (((now - prev) / prev) * 100).toFixed(1) + '%';
                                                            };

                                                            return (
                                                                <tr key={r.id ?? `${subregion}-${i}`}>
                                                                <td>{String(subregion)}</td>
                                                                <td>{mesAnt || '-'}</td>
                                                                <td>{mesUlt || '-'}</td>
                                                                <td style={{ textAlign: 'right' }}>{hogaresUlt === 0 ? '-' : hogaresUlt.toLocaleString()}</td>
                                                                <td style={{ textAlign: 'right' }}>{hogaresAnt === 0 ? '-' : hogaresAnt.toLocaleString()}</td>
                                                                <td style={{ textAlign: 'right' }}>{pct(hogaresUlt, hogaresAnt)}</td>
                                                                <td style={{ textAlign: 'right' }}>{personasUlt === 0 ? '-' : personasUlt.toLocaleString()}</td>
                                                                <td style={{ textAlign: 'right' }}>{personasAnt === 0 ? '-' : personasAnt.toLocaleString()}</td>
                                                                <td style={{ textAlign: 'right' }}>{pct(personasUlt, personasAnt)}</td>
                                                                </tr>
                                                            );
                                                            })}
                                                        </tbody>
                                                </table>
                                                </div>
                                            ) : (
                                                <p>No hay datos en el lado izquierdo.</p>
                                            )}
                                              <div>
                                                <div className="form-group">
                                                  <label htmlFor="datosPaginaCuatro.leftSide.texto">Texto observaci&oacute;n</label>
                                                  <textarea
                                                    id="datosPaginaCuatro.leftSide.texto"
                                                    className="form-control"
                                                    rows={3}
                                                    {...register('datosPaginaCuatro.leftSide.texto')}
                                                    placeholder="Ingrese texto descriptivo aquí"
                                                  />
                                                </div>
                                              </div>
                                            </div>

                                            <div className="col-md-6">
                                            <h6>Por Municipio</h6>
                                            <div style={{ marginBottom: 8 }}>
                                              <button 
                                              type="button" 
                                              className="btn btn-success"
                                              onClick={async () => { await downloadToExcel(rightRows, 'MunicipiosAntioquia.xlsx')}}>A Excel</button>
                                            </div>
                                            {rightSorted.length ? (
                                                <div style={{ overflowX: 'auto' }}>
                                                <table className="table table-sm table-striped">
                                                    <thead>
                                                    <tr>
                                                        <th style={{ minWidth: 160 }}>Municipio</th>
                                                        <th style={{ textAlign: 'right', minWidth: 110 }}>Hogares</th>
                                                        <th style={{ textAlign: 'right', minWidth: 110 }}>Personas</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {rightSorted.map((r, i) => {
                                                        const municipio = r.municipio ?? r.Municipio ?? r.nombre ?? '-';
                                                        const hogares = r.hogares ?? r.hogares_count ?? r.total_hogares ?? 0;
                                                        const personas = r.personas ?? r.total_personas ?? r.personas_count ?? 0;
                                                        return (
                                                        <tr key={r.id ?? `${municipio}-${i}`}>
                                                            <td>{String(municipio)}</td>
                                                            <td style={{ textAlign: 'right' }}>{(hogares === '' || hogares === null) ? '-' : Number(hogares).toLocaleString()}</td>
                                                            <td style={{ textAlign: 'right' }}>{(personas === '' || personas === null) ? '-' : Number(personas).toLocaleString()}</td>
                                                        </tr>
                                                        );
                                                    })}
                                                    </tbody>
                                                </table>
                                                </div>
                                            ) : (
                                                <p>No hay datos en el lado derecho.</p>
                                            )}
                                              <div>
                                                <div className="form-group">
                                                  <label htmlFor="datosPaginaCuatro.rightSide.texto">Texto observaci&oacute;n</label>
                                                  <textarea
                                                    id="datosPaginaCuatro.rightSide.texto"
                                                    className="form-control"
                                                    rows={3}
                                                    {...register('datosPaginaCuatro.rightSide.texto')}
                                                    placeholder="Ingrese texto descriptivo aquí"
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                        </div>
                                        </div>
                                    );
                                    })()}
                            </CardBody>
                        </Card>}
                        {getValues('fechaMesActual') && <Card style={{ marginTop: 20 }}>
                            <CardHeader>
                                <h3 className="card-title">Datos pagina cinco reporte</h3>
                            </CardHeader>
                            <CardBody>
                                {(() => {
                                    const d = watch('datosPaginaCinco') || {};

                                    const leftRows = Array.isArray(d.leftSide.datos)
                                    ? d.leftSide.datos
                                    : [];

                                    const rightRows = Array.isArray(d.rightSide.datos)
                                    ? d.rightSide.datos
                                    : [];

                                    const toNum = (v) => {
                                    if (v === undefined || v === null || v === '') return 0;
                                    const s = String(v).replace(/[^\d.-]/g, '');
                                    return s === '' ? 0 : Number(s);
                                    };

                                    // totals left
                                    const totalLeft = leftRows.reduce((acc, r) => {
                                    acc.hogaresUlt += toNum(r.hogaresUltimoMes ?? r.hogaresUltimo ?? r.hogares_ultimo_mes);
                                    acc.hogaresAnt += toNum(r.hogaresMesAnterior ?? r.hogaresMesAnt ?? r.hogares_mes_anterior);
                                    acc.personasUlt += toNum(r.personasUltimoMes ?? r.personasUltimo ?? r.personas_ultimo_mes);
                                    acc.personasAnt += toNum(r.personasMesAnterior ?? r.personasMesAnt ?? r.personas_mes_anterior);
                                    return acc;
                                    }, { hogaresUlt: 0, hogaresAnt: 0, personasUlt: 0, personasAnt: 0 });

                                    // totals right
                                    const totalRight = rightRows.reduce((acc, r) => {
                                    acc.hogares += toNum(r.hogares ?? r.hogares_count ?? r.total_hogares);
                                    acc.personas += toNum(r.personas ?? r.total_personas ?? r.personas_count);
                                    return acc;
                                    }, { hogares: 0, personas: 0 });

                                    const pct = (now, prev) => {
                                    if (prev === 0) return prev === now ? '0%' : '-';
                                    return (((now - prev) / prev) * 100).toFixed(1) + '%';
                                    };

                                    // sort left by hogaresUlt desc, right by hogares desc
                                    const leftSorted = [...leftRows].sort((a, b) =>
                                    toNum(b.hogaresUltimoMes ?? b.hogaresUltimo ?? b.hogares) - toNum(a.hogaresUltimoMes ?? a.hogaresUltimo ?? a.hogares)
                                    );
                                    const rightSorted = [...rightRows].sort((a, b) =>
                                    toNum(b.hogares ?? b.hogares_count) - toNum(a.hogares ?? a.hogares_count)
                                    );

                                    return (
                                    <div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
                                        <div>
                                            <strong>Left registros:</strong> {leftRows.length} &nbsp;&nbsp;
                                            <strong>Hogares último año:</strong> {totalLeft.hogaresUlt.toLocaleString()} &nbsp;&nbsp;
                                            <strong>Personas último año:</strong> {totalLeft.personasUlt.toLocaleString()}
                                        </div>
                                        <div>
                                            <strong>Right registros:</strong> {rightRows.length} &nbsp;&nbsp;
                                            <strong>Hogares (deptos):</strong> {totalRight.hogares.toLocaleString()} &nbsp;&nbsp;
                                            <strong>Personas (deptos):</strong> {totalRight.personas.toLocaleString()}
                                        </div>
                                        </div>

                                        <div className="row">
                                        <div className="col-md-6">
                                            <h6>Left — por Departamento (último / anterior)</h6>
                                            <div style={{ marginBottom: 8 }}>
                                                <button 
                                                type="button" 
                                                className="btn btn-success"
                                                onClick={async () => { await downloadToExcel(leftRows, 'SubregionesAntioquia.xlsx')}}>A Excel</button>
                                            </div>
                                            {leftSorted.length ? (
                                            <div style={{ overflowX: 'auto' }}>
                                                <table className="table table-sm table-striped">
                                                <thead>
                                                    <tr>
                                                    <th style={{ minWidth: 160 }}>Departamento</th>
                                                    <th style={{ minWidth: 100 }}>Año (ant)</th>
                                                    <th style={{ minWidth: 100 }}>Año (últ)</th>
                                                    <th style={{ textAlign: 'right', minWidth: 110 }}>Hogares (últ)</th>
                                                    <th style={{ textAlign: 'right', minWidth: 110 }}>Hogares (ant)</th>
                                                    <th style={{ textAlign: 'right', minWidth: 110 }}>Δ Hogares</th>
                                                    <th style={{ textAlign: 'right', minWidth: 110 }}>Personas (últ)</th>
                                                    <th style={{ textAlign: 'right', minWidth: 110 }}>Personas (ant)</th>
                                                    <th style={{ textAlign: 'right', minWidth: 110 }}>Δ Personas</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {leftSorted.map((r, i) => {
                                                    const departamento = r.departamento ?? '-';
                                                    const mesAnt = r.mesAnterior ?? r.mesAnt ?? r.mes_anterior ?? '';
                                                    const mesUlt = r.ultimoMes ?? r.mesUltimo ?? r.ultimo_mes ?? '';
                                                    const hogaresUlt = toNum(r.hogaresUltimoMes ?? r.hogaresUltimo ?? r.hogares_ultimo_mes ?? r.hogares ?? 0);
                                                    const hogaresAnt = toNum(r.hogaresMesAnterior ?? r.hogaresMesAnt ?? r.hogares_mes_anterior ?? 0);
                                                    const personasUlt = toNum(r.personasUltimoMes ?? r.personasUltimo ?? r.personas_ultimo_mes ?? r.personas ?? 0);
                                                    const personasAnt = toNum(r.personasMesAnterior ?? r.personasMesAnt ?? r.personas_mes_anterior ?? 0);

                                                    return (
                                                        <tr key={r.id ?? `${departamento}-${i}`}>
                                                        <td>{String(departamento)}</td>
                                                        <td>{mesAnt || '-'}</td>
                                                        <td>{mesUlt || '-'}</td>
                                                        <td style={{ textAlign: 'right' }}>{hogaresUlt === 0 ? '-' : hogaresUlt.toLocaleString()}</td>
                                                        <td style={{ textAlign: 'right' }}>{hogaresAnt === 0 ? '-' : hogaresAnt.toLocaleString()}</td>
                                                        <td style={{ textAlign: 'right' }}>{pct(hogaresUlt, hogaresAnt)}</td>
                                                        <td style={{ textAlign: 'right' }}>{personasUlt === 0 ? '-' : personasUlt.toLocaleString()}</td>
                                                        <td style={{ textAlign: 'right' }}>{personasAnt === 0 ? '-' : personasAnt.toLocaleString()}</td>
                                                        <td style={{ textAlign: 'right' }}>{pct(personasUlt, personasAnt)}</td>
                                                        </tr>
                                                    );
                                                    })}
                                                </tbody>
                                                </table>
                                            </div>
                                            ) : (
                                            <p>No hay datos en el lado izquierdo.</p>
                                            )}
                                            <div>
                                              <div className="form-group">
                                                <label htmlFor="datosPaginaCinco.leftSide.texto">Texto observaci&oacute;n</label>
                                                <textarea
                                                  id="datosPaginaCinco.leftSide.texto"
                                                  className="form-control"
                                                  rows={3}
                                                  {...register('datosPaginaCinco.leftSide.texto')}
                                                  placeholder="Ingrese texto descriptivo aquí"
                                                />
                                              </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <h6>Right — por Municipio</h6>
                                            <div style={{ marginBottom: 8 }}>
                                                <button 
                                                type="button" 
                                                className="btn btn-success"
                                                onClick={async () => { await downloadToExcel(rightRows, 'MunicipiosAntioquia.xlsx')}}>A Excel</button>
                                            </div>
                                            {rightSorted.length ? (
                                            <div style={{ overflowX: 'auto' }}>
                                                <table className="table table-sm table-striped">
                                                <thead>
                                                    <tr>
                                                    <th style={{ minWidth: 160 }}>Municipio</th>
                                                    <th style={{ textAlign: 'right', minWidth: 110 }}>Hogares</th>
                                                    <th style={{ textAlign: 'right', minWidth: 110 }}>Personas</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {rightSorted.map((r, i) => {
                                                    const municipio = r.municipio ?? r.Municipio ?? r.mun ?? '-';
                                                    const hogares = toNum(r.hogares ?? r.hogares_count ?? r.total_hogares ?? 0);
                                                    const personas = toNum(r.personas ?? r.total_personas ?? r.personas_count ?? 0);
                                                    return (
                                                        <tr key={r.id ?? `${municipio}-${i}`}>
                                                        <td>{String(municipio)}</td>
                                                        <td style={{ textAlign: 'right' }}>{hogares === 0 ? '-' : hogares.toLocaleString()}</td>
                                                        <td style={{ textAlign: 'right' }}>{personas === 0 ? '-' : personas.toLocaleString()}</td>
                                                        </tr>
                                                    );
                                                    })}
                                                </tbody>
                                                </table>
                                            </div>
                                            ) : (
                                            <p>No hay datos en el lado derecho.</p>
                                            )}
                                              <div>
                                                <div className="form-group">
                                                  <label htmlFor="datosPaginaCinco.rightSide.texto">Texto observaci&oacute;n</label>
                                                  <textarea
                                                    id="datosPaginaCinco.rightSide.texto"
                                                    className="form-control"
                                                    rows={3}
                                                    {...register('datosPaginaCinco.rightSide.texto')}
                                                    placeholder="Ingrese texto descriptivo aquí"
                                                  />
                                                </div>
                                              </div>          
                                          </div>
                                        </div>
                                    </div>
                                    );
                                })()}
                            </CardBody>
                        </Card>}
                        {getValues('fechaMesActual') && <Card style={{ marginTop: 20 }}>
                          <CardHeader>
                            <h3 className="card-title">Datos pagina seis reporte</h3>
                          </CardHeader>
                          <CardBody>
                            {(() => {
                              const d = watch('datosPaginaSeis') || {};

                              const graf1 = Array.isArray(d.graficaUnoData)
                                ? d.graficaUnoData
                                : Array.isArray(d.grafica_uno_data)
                                ? d.grafica_uno_data
                                : Array.isArray(d.graficaUno)
                                ? d.graficaUno
                                : [];

                              const graf2 = Array.isArray(d.graficaDosData)
                                ? d.graficaDosData
                                : Array.isArray(d.grafica_dos_data)
                                ? d.grafica_dos_data
                                : Array.isArray(d.graficaDos)
                                ? d.graficaDos
                                : [];

                              const toNum = (v) => {
                                if (v === undefined || v === null || v === '') return 0;
                                const s = String(v).replace(/[^\d.-]/g, '');
                                return s === '' ? 0 : Number(s);
                              };

                              const total1 = graf1.reduce((acc, r) => acc + toNum(r.total), 0);
                              const total2 = graf2.reduce((acc, r) => acc + toNum(r.total), 0);

                              const pct = (val, tot) => {
                                if (tot === 0) return '-';
                                return ((toNum(val) / tot) * 100).toFixed(1) + '%';
                              };

                              return (
                                <div>
                                  <div className="form-group">
                                    <label>Texto (lado derecho)</label>
                                    <textarea
                                      className="form-control"
                                      rows={3}
                                      {...register('datosPaginaSeis.textoRight')}
                                      defaultValue={d.textoRight ?? d.texto_right ?? ''}
                                    />
                                  </div>

                                  <div style={{ display: 'flex', gap: 12, marginTop: 12 }}>
                                    <div style={{ flex: 1 }}>
                                      <h6>Gráfica 1 — Etnias</h6>
                                      <div style={{ marginBottom: 8 }}>
                                        <button 
                                          type="button" 
                                          className="btn btn-success"
                                          onClick={async () => { await downloadToExcel(graf1, 'Etnias.xlsx')}}>A Excel</button>
                                      </div>
                                      {graf1.length ? (
                                        <div style={{ overflowX: 'auto' }}>
                                          <table className="table table-sm table-striped">
                                            <thead>
                                              <tr>
                                                <th>Etnia</th>
                                                <th style={{ textAlign: 'right' }}>Total</th>
                                                <th style={{ textAlign: 'right' }}>%</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {graf1
                                                .slice()
                                                .sort((a, b) => toNum(b.total) - toNum(a.total))
                                                .map((r, i) => (
                                                  <tr key={r.etnia ?? r.id ?? i}>
                                                    <td>{String(r.etnia ?? r.nombre ?? '-')}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                      {toNum(r.total) === 0 ? '-' : toNum(r.total).toLocaleString()}
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>{pct(r.total, total1)}</td>
                                                  </tr>
                                                ))}
                                              <tr>
                                                <td><strong>Total</strong></td>
                                                <td style={{ textAlign: 'right' }}><strong>{total1.toLocaleString()}</strong></td>
                                                <td />
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      ) : (
                                        <p>No hay datos para la gráfica 1.</p>
                                      )}
                                    </div>

                                    <div style={{ flex: 1 }}>
                                      <h6>Gráfica 2 — Departamentos</h6>
                                      <div style={{ marginBottom: 8 }}>
                                        <button 
                                          type="button" 
                                          className="btn btn-success"
                                          onClick={async () => { await downloadToExcel(graf2, 'Departamentos.xlsx')}}>A Excel</button>
                                      </div>
                                      {graf2.length ? (
                                        <div style={{ overflowX: 'auto' }}>
                                          <table className="table table-sm table-striped">
                                            <thead>
                                              <tr>
                                                <th>Departamento</th>
                                                <th style={{ textAlign: 'right' }}>Total</th>
                                                <th style={{ textAlign: 'right' }}>%</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {graf2
                                                .slice()
                                                .sort((a, b) => toNum(b.total) - toNum(a.total))
                                                .map((r, i) => (
                                                  <tr key={r.id ?? `dept-${i}`}>
                                                    <td>{String(r.departamento ?? r.nombre ?? '-')}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                      {toNum(r.total) === 0 ? '-' : toNum(r.total).toLocaleString()}
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>{pct(r.total, total2)}</td>
                                                  </tr>
                                                ))}
                                              <tr>
                                                <td><strong>Total</strong></td>
                                                <td style={{ textAlign: 'right' }}><strong>{total2.toLocaleString()}</strong></td>
                                                <td />
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      ) : (
                                        <p>No hay datos para la gráfica 2.</p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })()}
                          </CardBody>
                        </Card>}
                        {getValues('fechaMesActual') && <Card style={{ marginTop: 20 }}>
                          <CardHeader>
                            <h3 className="card-title">Datos pagina siete reporte</h3>
                          </CardHeader>
                          <CardBody>
                            {(() => {
                              const d = watch('datosPaginaSiete') || {};

                              const graf1 = Array.isArray(d.graficaUnoData)
                                ? d.graficaUnoData
                                : [];

                              const graf2 = Array.isArray(d.graficaDosData)
                                ? d.graficaDosData
                                : [];

                              const toNum = (v) => {
                                if (v === undefined || v === null || v === '') return 0;
                                const s = String(v).replace(/[^\d.-]/g, '');
                                return s === '' ? 0 : Number(s);
                              };

                              const total1 = graf1.reduce((acc, r) => acc + toNum(r.total), 0);

                              const pct = (val, tot) => {
                                if (tot === 0) return '-';
                                return ((toNum(val) / tot) * 100).toFixed(1) + '%';
                              };

                              return (
                                <div>
                                  <div className="form-group">
                                    <label>Texto Cualitativo 1</label>
                                    <textarea
                                      className="form-control"
                                      rows={2}
                                      {...register('datosPaginaSiete.textoCualitativo')}
                                      placeholder="Ej: 53.7% de las personas atendidas provenientes de otros municipios fueron mujeres."
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Texto Cualitativo 2</label>
                                    <textarea
                                      className="form-control"
                                      rows={2}
                                      {...register('datosPaginaSiete.textoCualitativoDos')}
                                      placeholder="Ej: Los NNAJ con edades entre los 0 y los 17 años..."
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Texto Cualitativo 3</label>
                                    <textarea
                                      className="form-control"
                                      rows={2}
                                      {...register('datosPaginaSiete.textoCualitativoTres')}
                                      placeholder="Ej: Las personas de edades entre los 26 a 59 años..."
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Texto Cualitativo 4</label>
                                    <textarea
                                      className="form-control"
                                      rows={2}
                                      {...register('datosPaginaSiete.textoCualitativoCuatro')}
                                      placeholder="Ej: 1 persona que se reconoció como población OSIEGD fue atendida."
                                    />
                                  </div>

                                  <div style={{ display: 'flex', gap: 12, marginTop: 12 }}>
                                    <div style={{ flex: 1 }}>
                                      <h6>Gráfica 1 — Personas por Sexo</h6>
                                      <div style={{ marginBottom: 8 }}>
                                        <button 
                                          type="button" 
                                          className="btn btn-success"
                                          onClick={async () => { await downloadToExcel(graf1, 'PersonasPorSexo.xlsx')}}>A Excel</button>
                                      </div>
                                      {graf1.length ? (
                                        <div style={{ overflowX: 'auto' }}>
                                          <table className="table table-sm table-striped">
                                            <thead>
                                              <tr>
                                                <th>Sexo</th>
                                                <th style={{ textAlign: 'right' }}>Total</th>
                                                <th style={{ textAlign: 'right' }}>%</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {graf1
                                                .slice()
                                                .sort((a, b) => toNum(b.total) - toNum(a.total))
                                                .map((r, i) => (
                                                  <tr key={`${r.categoria}-${i}`}>
                                                    <td>{String(r.categoria ?? '-')}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                      {toNum(r.total) === 0 ? '-' : toNum(r.total).toLocaleString()}
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>{pct(r.total, total1)}</td>
                                                  </tr>
                                                ))}
                                              <tr>
                                                <td colSpan={1}><strong>Total</strong></td>
                                                <td style={{ textAlign: 'right' }}><strong>{total1.toLocaleString()}</strong></td>
                                                <td />
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      ) : (
                                        <p>No hay datos para la gráfica 1.</p>
                                      )}
                                    </div>

                                    <div style={{ flex: 1 }}>
                                      <h6>Gráfica 2 — Personas por Grupo Etario y Sexo</h6>
                                      <div style={{ marginBottom: 8 }}>
                                        <button 
                                          type="button" 
                                          className="btn btn-success"
                                          onClick={async () => { await downloadToExcel(graf2, 'PersonasPorGrupoEtarioYSexo.xlsx')}}>A Excel</button>
                                      </div>
                                      {graf2.length ? (
                                        <div style={{ overflowX: 'auto' }}>
                                          <table className="table table-sm table-striped">
                                            <thead>
                                              <tr>
                                                <th>Grupo Etario</th>
                                                <th style={{ textAlign: 'right' }}>Hombres</th>
                                                <th style={{ textAlign: 'right' }}>Mujeres</th>
                                                <th style={{ textAlign: 'right' }}>Intersexual</th>
                                                <th style={{ textAlign: 'right' }}>Indefinido</th>
                                                <th style={{ textAlign: 'right' }}>Total</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {graf2.map((r, i) => {
                                                const h = toNum(r.hombres);
                                                const m = toNum(r.mujeres);
                                                const inter = toNum(r.intersexual);
                                                const indef = toNum(r.indefinido);
                                                const rowTotal = h + m + inter + indef;
                                                
                                                const displayLabel = String(r.grupoetareo ?? r.categoria ?? '-')
                                                  .replace('de_', '')
                                                  .replace(/_/g, ' ')
                                                  .replace('anios', 'años')
                                                  .replace('0 mas', '0 o más');

                                                return (
                                                  <tr key={r.grupoetareo ?? r.categoria ?? i}>
                                                    <td>{displayLabel}</td>
                                                    <td style={{ textAlign: 'right' }}>{h || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}>{m || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}>{inter || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}>{indef || '-'}</td>
                                                    <td style={{ textAlign: 'right' }}><strong>{rowTotal}</strong></td>
                                                  </tr>
                                                );
                                              })}
                                              <tr>
                                                <td><strong>Total</strong></td>
                                                <td style={{ textAlign: 'right' }}>
                                                  <strong>{graf2.reduce((acc, r) => acc + toNum(r.hombres), 0)}</strong>
                                                </td>
                                                <td style={{ textAlign: 'right' }}>
                                                  <strong>{graf2.reduce((acc, r) => acc + toNum(r.mujeres), 0)}</strong>
                                                </td>
                                                <td style={{ textAlign: 'right' }}>
                                                  <strong>{graf2.reduce((acc, r) => acc + toNum(r.intersexual), 0)}</strong>
                                                </td>
                                                <td style={{ textAlign: 'right' }}>
                                                  <strong>{graf2.reduce((acc, r) => acc + toNum(r.indefinido), 0)}</strong>
                                                </td>
                                                <td style={{ textAlign: 'right' }}>
                                                  <strong>
                                                    {graf2.reduce((acc, r) => 
                                                      acc + toNum(r.hombres) + toNum(r.mujeres) + toNum(r.intersexual) + toNum(r.indefinido), 0
                                                    )}
                                                  </strong>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      ) : (
                                        <p>No hay datos para la gráfica 2.</p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })()}
                          </CardBody>
                        </Card>}
                        {getValues('fechaMesActual') && <Card style={{ marginTop: 20 }}>
                          <CardHeader>
                            <h3 className="card-title">Datos pagina ocho reporte</h3>
                          </CardHeader>
                          <CardBody>
                            {(() => {
                              const d = watch('datosPaginaOcho') || {};

                              const graficaData = Array.isArray(d.graficaUnoData)
                                ? d.graficaUnoData
                                : [];

                              const toNum = (v) => {
                                if (v === undefined || v === null || v === '') return 0;
                                const s = String(v).replace(/[^\d.-]/g, '');
                                return s === '' ? 0 : Number(s);
                              };

                              const total = graficaData.reduce((acc, r) => acc + toNum(r.total), 0);

                              const pct = (val, tot) => {
                                if (tot === 0) return '-';
                                return ((toNum(val) / tot) * 100).toFixed(1) + '%';
                              };

                              return (
                                <div>
                                  <div className="form-group">
                                    <label>Texto Cualitativo</label>
                                    <textarea
                                      className="form-control"
                                      rows={3}
                                      {...register('datosPaginaOcho.textoCualitativo')}
                                      placeholder="Ej: En el año se atendieron nueve (9) personas de nacionalidad venezolana..."
                                    />
                                  </div>

                                  <div style={{ marginTop: 12 }}>
                                    <h6>Gráfica — Personas por País de Origen</h6>
                                    <div style={{ marginBottom: 8 }}>
                                      <button 
                                        type="button" 
                                        className="btn btn-success"
                                        onClick={async () => { await downloadToExcel(graficaData, 'PersonasPorPaisDeOrigen.xlsx')}}>A Excel</button>
                                    </div>
                                    {graficaData.length ? (
                                      <div style={{ overflowX: 'auto' }}>
                                        <table className="table table-sm table-striped">
                                          <thead>
                                            <tr>
                                              <th>País de Origen</th>
                                              <th style={{ textAlign: 'right' }}>Total</th>
                                              <th style={{ textAlign: 'right' }}>%</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {graficaData
                                              .slice()
                                              .sort((a, b) => toNum(b.total) - toNum(a.total))
                                              .map((r, i) => (
                                                <tr key={`${r.categoria}-${r.departamento}-${i}`}>
                                                  <td>{String(r.categoria ?? '-')}</td>
                                                  <td style={{ textAlign: 'right' }}>
                                                    {toNum(r.total) === 0 ? '-' : toNum(r.total).toLocaleString()}
                                                  </td>
                                                  <td style={{ textAlign: 'right' }}>{pct(r.total, total)}</td>
                                                </tr>
                                              ))}
                                            <tr>
                                              <td><strong>Total</strong></td>
                                              <td style={{ textAlign: 'right' }}><strong>{total.toLocaleString()}</strong></td>
                                              <td />
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    ) : (
                                      <p>No hay datos para la gráfica.</p>
                                    )}
                                  </div>
                                </div>
                              );
                            })()}
                          </CardBody>
                        </Card>}
                        {getValues('fechaMesActual') && <Card style={{ marginTop: 20 }}>
                          <CardHeader>
                            <h3 className="card-title">Datos pagina nueve reporte</h3>
                          </CardHeader>
                          <CardBody>
                            {(() => {
                              const d = watch('datosPaginaNueve') || {};

                              return (
                                <div>
                                  <div className="form-group">
                                    <label>Título (Subtítulo)</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register('datosPaginaNueve.subTitle')}
                                      placeholder="Ej: ANTIOQUIA - CIUDAD BOLIVAR"
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Texto (Descripción del Riesgo)</label>
                                    <textarea
                                      className="form-control"
                                      rows={5}
                                      {...register('datosPaginaNueve.texto')}
                                      placeholder="Ej: Riesgo: Durante el año arribaron a Medellín..."
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Recomendaciones</label>
                                    <textarea
                                      className="form-control"
                                      rows={8}
                                      {...register('datosPaginaNueve.recomendaciones')}
                                      placeholder="Ej: 1. Fortalecer la articulación con las entidades territoriales..."
                                    />
                                  </div>

                                  {(d.titulo || d.texto || d.recomendaciones) && (
                                    <div style={{ marginTop: 20, padding: 15, backgroundColor: '#f8f9fa', borderRadius: 5 }}>
                                      <h6 style={{ marginBottom: 10 }}>Vista Previa:</h6>
                                      {d.subTitle && (
                                        <div style={{ marginBottom: 10 }}>
                                          <strong>Subtítulo:</strong> {d.subTitle}
                                        </div>
                                      )}
                                      {d.texto && (
                                        <div style={{ marginBottom: 10 }}>
                                          <strong>Texto:</strong>
                                          <p style={{ marginTop: 5, whiteSpace: 'pre-wrap' }}>{d.texto}</p>
                                        </div>
                                      )}
                                      {d.recomendaciones && (
                                        <div>
                                          <strong>Recomendaciones:</strong>
                                          <p style={{ marginTop: 5, whiteSpace: 'pre-wrap' }}>{d.recomendaciones}</p>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              );
                            })()}
                          </CardBody>
                        </Card>}
                        {getValues('fechaMesActual') && <Card style={{ marginTop: 20 }}>
                          <CardHeader>
                            <h3 className="card-title">Datos pagina diez reporte</h3>
                          </CardHeader>
                          <CardBody>
                            {(() => {
                              const d = watch('datosPaginaDiez') || {};

                              return (
                                <div>
                                  <div className="form-group">
                                    <label>Título (Subtítulo)</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register('datosPaginaDiez.subTitle')}
                                      placeholder="Ej: ANTIOQUIA - ZARAGOZA"
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Texto (Descripción del Riesgo)</label>
                                    <textarea
                                      className="form-control"
                                      rows={5}
                                      {...register('datosPaginaDiez.texto')}
                                      placeholder="Ej: Riesgo: durante el año llegaron a Medellín..."
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Recomendaciones</label>
                                    <textarea
                                      className="form-control"
                                      rows={8}
                                      {...register('datosPaginaDiez.recomendaciones')}
                                      placeholder="Ej: 1. Fortalecer la articulación con las entidades territoriales..."
                                    />
                                  </div>

                                  {(d.subTitle || d.texto || d.recomendaciones) && (
                                    <div style={{ marginTop: 20, padding: 15, backgroundColor: '#f8f9fa', borderRadius: 5 }}>
                                      <h6 style={{ marginBottom: 10 }}>Vista Previa:</h6>
                                      {d.subTitle && (
                                        <div style={{ marginBottom: 10 }}>
                                          <strong>Subtítulo:</strong> {d.subTitle}
                                        </div>
                                      )}
                                      {d.texto && (
                                        <div style={{ marginBottom: 10 }}>
                                          <strong>Texto:</strong>
                                          <p style={{ marginTop: 5, whiteSpace: 'pre-wrap' }}>{d.texto}</p>
                                        </div>
                                      )}
                                      {d.recomendaciones && (
                                        <div>
                                          <strong>Recomendaciones:</strong>
                                          <p style={{ marginTop: 5, whiteSpace: 'pre-wrap' }}>{d.recomendaciones}</p>
                                        </div>
                                      )}
                                    </div>
                                  )}
                                </div>
                              );
                            })()}
                          </CardBody>
                        </Card>}
                        {getValues('fechaMesActual') && <Card style={{ marginTop: 20 }}>
                          <CardHeader>
                            <h3 className="card-title">Datos pagina once reporte Intraurbano</h3>
                            <div style={{ marginBottom: 8 }}>
                              <button 
                                type="button" 
                                className="btn btn-success"
                                onClick={async () => { await downloadToExcel(watch('datosPaginaOnce'), 'Intraurbano.xlsx')}}>A Excel</button>
                            </div>
                          </CardHeader>
                          <CardBody>
                            {(() => {
                              const d = watch('datosPaginaOnce') || {};
                              const toNum = (v) => {
                                if (v === undefined || v === null || v === '') return NaN;
                                const s = String(v).replace(/[^\d.-]/g, '');
                                return s === '' ? NaN : Number(s);
                              };

                              // Monthly keys
                              const hogaresNow = toNum(d.hogaresUltimoMes ?? d.hogaresUltimo_mes ?? d.hogaresUltimo ?? d.hogaresMesActual);
                              const hogaresPrev = toNum(d.hogaresMesAnterior ?? d.hogares_mes_anterior ?? d.hogaresMesAnt ?? d.hogaresMesAnterior);
                              const personasNow = toNum(d.personasUltimoMes ?? d.personasUltimo_mes ?? d.personasUltimo ?? d.personasMesActual);
                              const personasPrev = toNum(d.personasMesAnterior ?? d.personas_mes_anterior ?? d.personasMesAnt ?? d.personasMesAnterior);

                              // Annual keys
                              const hogaresYearNow = toNum(d.hogaresAnioActual ?? d.hogaresAnoActual ?? d.hogaresAnual ?? d.hogaresAnio ?? d.hogaresAnioActual);
                              const hogaresYearPrev = toNum(d.hogaresAnioAnterior ?? d.hogaresAnoAnterior ?? d.hogaresAnioAnt ?? d.hogaresAnioAnterior);
                              const personasYearNow = toNum(d.personasAnioActual ?? d.personasAnoActual ?? d.personasAnual ?? d.personasAnio);
                              const personasYearPrev = toNum(d.personasAnioAnterior ?? d.personasAnoAnterior ?? d.personasAnioAnt ?? d.personasAnioAnterior);

                              const pct = (a, b) => {
                                if (Number.isNaN(a) || Number.isNaN(b) || b === 0) return '-';
                                return (((a - b) / b * 100).toFixed(1) + '%');
                              };

                              const hasMonthly = !Number.isNaN(hogaresNow) || !Number.isNaN(personasNow) || !Number.isNaN(hogaresPrev) || !Number.isNaN(personasPrev);
                              const hasAnnual = !Number.isNaN(hogaresYearNow) || !Number.isNaN(personasYearNow) || !Number.isNaN(hogaresYearPrev) || !Number.isNaN(personasYearPrev);

                              return (
                                <div>
                                  {d.fechaMesActual && (
                                    <div style={{ marginBottom: 12, padding: 10, backgroundColor: '#e3f2fd', borderRadius: 4 }}>
                                      <strong>Período:</strong> {d.fechaMesActual}
                                    </div>
                                  )}

                                  <div style={{ marginBottom: 12 }}>
                                    <strong>Resumen</strong>
                                  </div>

                                  {hasMonthly ? (
                                    <div style={{ marginBottom: 16 }}>
                                      <div style={{ marginBottom: 6 }}><strong>Resumen anual</strong></div>
                                      <div className="row">
                                        <div className="col-md-6">
                                          <h6>Hogares</h6>
                                          <ul className="list-unstyled">
                                            <li>Último año: {Number.isNaN(hogaresNow) ? '-' : hogaresNow.toLocaleString()}</li>
                                            <li>Año anterior: {Number.isNaN(hogaresPrev) ? '-' : hogaresPrev.toLocaleString()}</li>
                                            <li>Cambio: {pct(hogaresNow, hogaresPrev)}</li>
                                          </ul>
                                        </div>

                                        <div className="col-md-6">
                                          <h6>Personas</h6>
                                          <ul className="list-unstyled">
                                            <li>Último año: {Number.isNaN(personasNow) ? '-' : personasNow.toLocaleString()}</li>
                                            <li>Año anterior: {Number.isNaN(personasPrev) ? '-' : personasPrev.toLocaleString()}</li>
                                            <li>Cambio: {pct(personasNow, personasPrev)}</li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}

                                  {hasAnnual ? (
                                    <div style={{ marginBottom: 8 }}>
                                      <div style={{ marginBottom: 6 }}><strong>Resumen anual</strong></div>
                                      <div className="row">
                                        <div className="col-md-6">
                                          <h6>Hogares (Año)</h6>
                                          <ul className="list-unstyled">
                                            <li>Año actual: {Number.isNaN(hogaresYearNow) ? '-' : hogaresYearNow.toLocaleString()}</li>
                                            <li>Año anterior: {Number.isNaN(hogaresYearPrev) ? '-' : hogaresYearPrev.toLocaleString()}</li>
                                            <li>Cambio anual: {pct(hogaresYearNow, hogaresYearPrev)}</li>
                                          </ul>
                                        </div>

                                        <div className="col-md-6">
                                          <h6>Personas (Año)</h6>
                                          <ul className="list-unstyled">
                                            <li>Año actual: {Number.isNaN(personasYearNow) ? '-' : personasYearNow.toLocaleString()}</li>
                                            <li>Año anterior: {Number.isNaN(personasYearPrev) ? '-' : personasYearPrev.toLocaleString()}</li>
                                            <li>Cambio anual: {pct(personasYearNow, personasYearPrev)}</li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}

                                  {!hasMonthly && !hasAnnual && Object.keys(d).length ? (
                                    <div style={{ marginTop: 12 }}>
                                      <strong>Datos recibidos (sin campos esperados):</strong>
                                      <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{JSON.stringify(d, null, 2)}</pre>
                                    </div>
                                  ) : null}
                                </div>
                              );
                            })()}
                          </CardBody>
                        </Card>}
                        {getValues('fechaMesActual') && <Card style={{ marginTop: 20 }}>
                          <CardHeader>
                            <h3 className="card-title">Datos pagina doce reporte</h3>
                          </CardHeader>
                          <CardBody>
                            {(() => {
                              const d = watch('datosPaginaDoce') || {};

                              return (
                                <div>
                                  {d.titulo ? (
                                    <div style={{ padding: 15, backgroundColor: '#f8f9fa', borderRadius: 5 }}>
                                      <h6 style={{ marginBottom: 10 }}>Título:</h6>
                                      <p>{d.titulo}</p>
                                    </div>
                                  ) : (
                                    <p className="text-muted">No hay datos para la página doce.</p>
                                  )}
                                </div>
                              );
                            })()}
                          </CardBody>
                        </Card>}
                        {getValues('fechaMesActual') && <Card style={{ marginTop: 20 }}>
                          <CardHeader>
                            <h3 className="card-title">Datos pagina trece reporte</h3>
                          </CardHeader>
                          <CardBody>
                            {(() => {
                              const d = watch('datosPaginaTrece') || {};

                              const graficaData = Array.isArray(d.graficaData)
                                ? d.graficaData
                                : [];

                              const toNum = (v) => {
                                if (v === undefined || v === null || v === '') return 0;
                                const s = String(v).replace(/[^\d.-]/g, '');
                                return s === '' ? 0 : Number(s);
                              };

                              const totalHogaresUltimoMes = graficaData.reduce((acc, r) => acc + toNum(r.hogaresUltimoMes), 0);
                              const totalPersonasUltimoMes = graficaData.reduce((acc, r) => acc + toNum(r.personasUltimoMes), 0);
                              const totalHogaresMesAnterior = graficaData.reduce((acc, r) => acc + toNum(r.hogaresMesAnterior), 0);
                              const totalPersonasMesAnterior = graficaData.reduce((acc, r) => acc + toNum(r.personasMesAnterior), 0);

                              return (
                                <div>
                                  <div className="form-group">
                                    <label>Texto 1</label>
                                    <textarea
                                      className="form-control"
                                      rows={3}
                                      {...register('datosPaginaTrece.textoRight.textoUno')}
                                      placeholder="Ej: Durante el año se registraron casos de DFI..."
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Texto 2</label>
                                    <textarea
                                      className="form-control"
                                      rows={3}
                                      {...register('datosPaginaTrece.textoRight.textoDos')}
                                      placeholder="Ej: Cabe resaltar que las comunas..."
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Texto 3</label>
                                    <textarea
                                      className="form-control"
                                      rows={2}
                                      {...register('datosPaginaTrece.textoRight.textoTres')}
                                      placeholder="Ej: En la comuna 3 - Manrique..."
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Texto 4</label>
                                    <textarea
                                      className="form-control"
                                      rows={2}
                                      {...register('datosPaginaTrece.textoRight.textoCuatro')}
                                      placeholder="Ej: A escala microterritorial..."
                                    />
                                  </div>

                                  <div style={{ marginTop: 20 }}>
                                    <h6>Gráfica — Datos por Comuna y Barrio</h6>
                                    <div style={{ marginBottom: 8 }}>
                                      <button 
                                        type="button" 
                                        className="btn btn-success"
                                        onClick={async () => { await downloadToExcel(graficaData, 'DatosPorComunaYBarrio.xlsx')}}>A Excel</button>
                                    </div>
                                    {graficaData.length ? (
                                      <div style={{ overflowX: 'auto' }}>
                                        <table className="table table-sm table-striped">
                                          <thead>
                                            <tr>
                                              <th>Comuna</th>
                                              <th style={{ textAlign: 'right' }}>Hogares Último Año</th>
                                              <th style={{ textAlign: 'right' }}>Personas Último Año</th>
                                              <th style={{ textAlign: 'right' }}>Hogares Año Anterior</th>
                                              <th style={{ textAlign: 'right' }}>Personas Año Anterior</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {graficaData
                                              .slice()
                                              .sort((a, b) => toNum(b.hogaresUltimoMes) - toNum(a.hogaresUltimoMes))
                                              .map((r, i) => (
                                                <tr key={`${r.comuna}-${i}`}>
                                                  <td>{String(r.comuna ?? '-')}</td>
                                                  <td style={{ textAlign: 'right' }}>
                                                    {toNum(r.hogaresUltimoMes) === 0 ? '-' : toNum(r.hogaresUltimoMes).toLocaleString()}
                                                  </td>
                                                  <td style={{ textAlign: 'right' }}>
                                                    {toNum(r.personasUltimoMes) === 0 ? '-' : toNum(r.personasUltimoMes).toLocaleString()}
                                                  </td>
                                                  <td style={{ textAlign: 'right' }}>
                                                    {toNum(r.hogaresMesAnterior) === 0 ? '-' : toNum(r.hogaresMesAnterior).toLocaleString()}
                                                  </td>
                                                  <td style={{ textAlign: 'right' }}>
                                                    {toNum(r.personasMesAnterior) === 0 ? '-' : toNum(r.personasMesAnterior).toLocaleString()}
                                                  </td>
                                                </tr>
                                              ))}
                                            <tr>
                                              <td colSpan={1}><strong>Total</strong></td>
                                              <td style={{ textAlign: 'right' }}><strong>{totalHogaresUltimoMes.toLocaleString()}</strong></td>
                                              <td style={{ textAlign: 'right' }}><strong>{totalPersonasUltimoMes.toLocaleString()}</strong></td>
                                              <td style={{ textAlign: 'right' }}><strong>{totalHogaresMesAnterior.toLocaleString()}</strong></td>
                                              <td style={{ textAlign: 'right' }}><strong>{totalPersonasMesAnterior.toLocaleString()}</strong></td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    ) : (
                                      <p>No hay datos para la gráfica.</p>
                                    )}
                                  </div>
                                </div>
                              );
                            })()}
                          </CardBody>
                        </Card>}
                        {getValues('fechaMesActual') && <Card style={{ marginTop: 20 }}>
                          <CardHeader>
                            <h3 className="card-title">Datos pagina catorce reporte</h3>
                          </CardHeader>
                          <CardBody>
                            {(() => {
                              const d = watch('datosPaginaCatorce') || {};

                              const graf1 = Array.isArray(d.graficaUnoData)
                                ? d.graficaUnoData
                                : [];

                              const graf2 = Array.isArray(d.graficaDosData)
                                ? d.graficaDosData
                                : [];

                              const toNum = (v) => {
                                if (v === undefined || v === null || v === '') return 0;
                                const s = String(v).replace(/[^\d.-]/g, '');
                                return s === '' ? 0 : Number(s);
                              };

                              const total1 = graf1.reduce((acc, r) => acc + toNum(r.total), 0);

                              // For graf2, sum all gender columns
                              const total2 = graf2.reduce((acc, r) => 
                                acc + toNum(r.hombres) + toNum(r.mujeres) + toNum(r.intersexual) + toNum(r.indefinido), 0
                              );

                              const pct = (val, tot) => {
                                if (tot === 0) return '-';
                                return ((toNum(val) / tot) * 100).toFixed(1) + '%';
                              };

                              return (
                                <div>
                                  <div className="form-group">
                                    <label>Texto Uno</label>
                                    <textarea
                                      className="form-control"
                                      rows={2}
                                      {...register('datosPaginaCatorce.textoRight.uno')}
                                      placeholder="Ej: 42,9% de las personas atendidas fueron mujeres."
                                      defaultValue={d.textoRight?.uno ?? ''}
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Texto Dos</label>
                                    <textarea
                                      className="form-control"
                                      rows={2}
                                      {...register('datosPaginaCatorce.textoRight.dos')}
                                      placeholder="Ej: 36,7% de las personas atendidas se encuentran en el grupo etareo de 26 a 59 años."
                                      defaultValue={d.textoRight?.dos ?? ''}
                                    />
                                  </div>

                                  <div style={{ display: 'flex', gap: 12, marginTop: 12 }}>
                                    <div style={{ flex: 1 }}>
                                      <h6>Gráfica 1 — Personas por Municipio y Sexo</h6>
                                      <div style={{ marginBottom: 8 }}>
                                        <button 
                                          type="button" 
                                          className="btn btn-success"
                                          onClick={async () => { await downloadToExcel(graf1, 'PersonasPorMunicipioYSexo.xlsx')}}>A Excel</button>
                                      </div>
                                      {graf1.length ? (
                                        <div style={{ overflowX: 'auto' }}>
                                          <table className="table table-sm table-striped">
                                            <thead>
                                              <tr>
                                                <th>Sexo</th>
                                                <th style={{ textAlign: 'right' }}>Total</th>
                                                <th style={{ textAlign: 'right' }}>%</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {graf1
                                                .slice()
                                                .sort((a, b) => toNum(b.total) - toNum(a.total))
                                                .map((r, i) => (
                                                  <tr key={`${r.sexoNombre}-${i}`}>
                                                    <td>{String(r.sexoNombre ?? '-')}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                      {toNum(r.total) === 0 ? '-' : toNum(r.total).toLocaleString()}
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>{pct(r.total, total1)}</td>
                                                  </tr>
                                                ))}
                                              <tr>
                                                <td colSpan={2}><strong>Total</strong></td>
                                                <td style={{ textAlign: 'right' }}><strong>{total1.toLocaleString()}</strong></td>
                                                <td />
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      ) : (
                                        <p>No hay datos para la gráfica 1.</p>
                                      )}
                                    </div>

                                    <div style={{ flex: 1 }}>
                                      <h6>Gráfica 2 — Personas por Grupo Etáreo</h6>
                                      <div style={{ marginBottom: 8 }}>
                                        <button 
                                          type="button" 
                                          className="btn btn-success"
                                          onClick={async () => { await downloadToExcel(graf2, 'PersonasPorGrupoEtarioYSexo.xlsx')}}>A Excel</button>
                                      </div>
                                      {graf2.length ? (
                                        <div style={{ overflowX: 'auto' }}>
                                          <table className="table table-sm table-striped">
                                            <thead>
                                              <tr>
                                                <th>Grupo Etáreo</th>
                                                <th style={{ textAlign: 'right' }}>Hombres</th>
                                                <th style={{ textAlign: 'right' }}>Mujeres</th>
                                                <th style={{ textAlign: 'right' }}>Total</th>
                                                <th style={{ textAlign: 'right' }}>%</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {graf2.map((r, i) => {
                                                const rowTotal = toNum(r.hombres) + toNum(r.mujeres) + toNum(r.intersexual) + toNum(r.indefinido);
                                                return (
                                                  <tr key={r.grupoEtareo ?? i}>
                                                    <td>{String(r.grupoEtareo ?? '-').replace(/_/g, ' ')}</td>
                                                    <td style={{ textAlign: 'right' }}>
                                                      {toNum(r.hombres) === 0 ? '-' : toNum(r.hombres).toLocaleString()}
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>
                                                      {toNum(r.mujeres) === 0 ? '-' : toNum(r.mujeres).toLocaleString()}
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>
                                                      {rowTotal === 0 ? '-' : rowTotal.toLocaleString()}
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>{pct(rowTotal, total2)}</td>
                                                  </tr>
                                                );
                                              })}
                                              <tr>
                                                <td><strong>Total</strong></td>
                                                <td style={{ textAlign: 'right' }}>
                                                  <strong>{graf2.reduce((acc, r) => acc + toNum(r.hombres), 0).toLocaleString()}</strong>
                                                </td>
                                                <td style={{ textAlign: 'right' }}>
                                                  <strong>{graf2.reduce((acc, r) => acc + toNum(r.mujeres), 0).toLocaleString()}</strong>
                                                </td>
                                                <td style={{ textAlign: 'right' }}><strong>{total2.toLocaleString()}</strong></td>
                                                <td />
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      ) : (
                                        <p>No hay datos para la gráfica 2.</p>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })()}
                          </CardBody>
                        </Card>}
                        {getValues('fechaMesActual') && <Card style={{ marginTop: 20 }}>
                          <CardHeader>
                            <h3 className="card-title">Datos pagina quince reporte</h3>
                          </CardHeader>
                          <CardBody>
                            {(() => {
                              const d = watch('datosPaginaQuince') || {};

                              const identidadGenero = Array.isArray(d.graficaDosData)
                                ? d.graficaDosData
                                : [];

                              const orientacionSexual = Array.isArray(d.graficaUnoData)
                                ? d.graficaUnoData
                                : [];

                              const toNum = (v) => {
                                if (v === undefined || v === null || v === '') return 0;
                                const s = String(v).replace(/[^\d.-]/g, '');
                                return s === '' ? 0 : Number(s);
                              };

                              const totalIdentidad = identidadGenero.reduce((acc, r) => acc + toNum(r.cantidad), 0);
                              const totalOrientacion = orientacionSexual.reduce((acc, r) => acc + toNum(r.cantidad), 0);

                              const pct = (val, tot) => {
                                if (tot === 0) return '-';
                                return ((toNum(val) / tot) * 100).toFixed(1) + '%';
                              };

                              return (
                                <div style={{ display: 'flex', gap: 12 }}>
                                  <div style={{ flex: 1 }}>
                                    <h6>Identidad de Género</h6>
                                    <div style={{ marginBottom: 8 }}>
                                      <button 
                                        type="button" 
                                        className="btn btn-success"
                                        onClick={async () => { await downloadToExcel(identidadGenero, 'IdentidadDeGenero.xlsx')}}>A Excel</button>
                                    </div>
                                    {identidadGenero.length ? (
                                      <div style={{ overflowX: 'auto' }}>
                                        <table className="table table-sm table-striped">
                                          <thead>
                                            <tr>
                                              <th>Identidad</th>
                                              <th style={{ textAlign: 'right' }}>Cantidad</th>
                                              <th style={{ textAlign: 'right' }}>%</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {identidadGenero
                                              .slice()
                                              .sort((a, b) => toNum(b.cantidad) - toNum(a.cantidad))
                                              .map((r, i) => (
                                                <tr key={r.id ?? `identidad-${i}`}>
                                                  <td>{String(r.identidad ?? '-')}</td>
                                                  <td style={{ textAlign: 'right' }}>
                                                    {toNum(r.cantidad) === 0 ? '-' : toNum(r.cantidad).toLocaleString()}
                                                  </td>
                                                  <td style={{ textAlign: 'right' }}>{pct(r.cantidad, totalIdentidad)}</td>
                                                </tr>
                                              ))}
                                            <tr>
                                              <td><strong>Total</strong></td>
                                              <td style={{ textAlign: 'right' }}><strong>{totalIdentidad.toLocaleString()}</strong></td>
                                              <td />
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    ) : (
                                      <p>No hay datos de identidad de género.</p>
                                    )}
                                  </div>

                                  <div style={{ flex: 1 }}>
                                    <h6>Orientación Sexual</h6>
                                    <div style={{ marginBottom: 8 }}>
                                      <button 
                                        type="button" 
                                        className="btn btn-success"
                                        onClick={async () => { await downloadToExcel(orientacionSexual, 'OrientacionSexual.xlsx')}}>A Excel</button>
                                    </div>
                                    {orientacionSexual.length ? (
                                      <div style={{ overflowX: 'auto' }}>
                                        <table className="table table-sm table-striped">
                                          <thead>
                                            <tr>
                                              <th>Orientación</th>
                                              <th style={{ textAlign: 'right' }}>Cantidad</th>
                                              <th style={{ textAlign: 'right' }}>%</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {orientacionSexual
                                              .slice()
                                              .sort((a, b) => toNum(b.cantidad) - toNum(a.cantidad))
                                              .map((r, i) => (
                                                <tr key={r.id ?? `orientacion-${i}`}>
                                                  <td>{String(r.orientacion ?? '-')}</td>
                                                  <td style={{ textAlign: 'right' }}>
                                                    {toNum(r.cantidad) === 0 ? '-' : toNum(r.cantidad).toLocaleString()}
                                                  </td>
                                                  <td style={{ textAlign: 'right' }}>{pct(r.cantidad, totalOrientacion)}</td>
                                                </tr>
                                              ))}
                                            <tr>
                                              <td><strong>Total</strong></td>
                                              <td style={{ textAlign: 'right' }}><strong>{totalOrientacion.toLocaleString()}</strong></td>
                                              <td />
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    ) : (
                                      <p>No hay datos de orientación sexual.</p>
                                    )}
                                  </div>
                                </div>
                              );
                            })()}
                          </CardBody>
                        </Card>}
                        {getValues('fechaMesActual') && <Card style={{ marginTop: 20 }}>
                          <CardHeader>
                            <h3 className="card-title">Datos pagina dieciseis reporte</h3>
                          </CardHeader>
                          <CardBody>
                            {(() => {
                              const d = watch('datosPaginaDieciseis') || {};

                              const paisesOrigen = Array.isArray(d.graficaUnoData)
                                ? d.graficaUnoData
                                : [];

                              const toNum = (v) => {
                                if (v === undefined || v === null || v === '') return 0;
                                const s = String(v).replace(/[^\d.-]/g, '');
                                return s === '' ? 0 : Number(s);
                              };

                              const totalPaises = paisesOrigen.reduce((acc, r) => acc + toNum(r.cantidad), 0);

                              const pct = (val, tot) => {
                                if (tot === 0) return '-';
                                return ((toNum(val) / tot) * 100).toFixed(1) + '%';
                              };

                              return (
                                <div>
                                  <h6>Países de Origen</h6>
                                  <div style={{ marginBottom: 8 }}>
                                    <button 
                                      type="button" 
                                      className="btn btn-success"
                                      onClick={async () => { await downloadToExcel(paisesOrigen, 'PaisesDeOrigen.xlsx')}}>A Excel</button>
                                  </div>
                                  {paisesOrigen.length ? (
                                    <div style={{ overflowX: 'auto' }}>
                                      <table className="table table-sm table-striped">
                                        <thead>
                                          <tr>
                                            <th>País</th>
                                            <th style={{ textAlign: 'right' }}>Cantidad</th>
                                            <th style={{ textAlign: 'right' }}>%</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {paisesOrigen
                                            .slice()
                                            .sort((a, b) => toNum(b.cantidad) - toNum(a.cantidad))
                                            .map((r, i) => (
                                              <tr key={r.id ?? `pais-${i}`}>
                                                <td>{String(r.pais ?? '-')}</td>
                                                <td style={{ textAlign: 'right' }}>
                                                  {toNum(r.cantidad) === 0 ? '-' : toNum(r.cantidad).toLocaleString()}
                                                </td>
                                                <td style={{ textAlign: 'right' }}>{pct(r.cantidad, totalPaises)}</td>
                                              </tr>
                                            ))}
                                          <tr>
                                            <td><strong>Total</strong></td>
                                            <td style={{ textAlign: 'right' }}><strong>{totalPaises.toLocaleString()}</strong></td>
                                            <td />
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  ) : (
                                    <p>No hay datos de países de origen.</p>
                                  )}
                                </div>
                              );
                            })()}
                          </CardBody>
                        </Card>}
                        {getValues('fechaMesActual') && <Card style={{ marginTop: 20 }}>
                          <CardHeader>
                            <h3 className="card-title">Datos pagina diecisiete reporte</h3>
                          </CardHeader>
                          <CardBody>
                            {(() => {
                              const d = watch('datosPaginaDiecisiete') || {};

                              const datos = Array.isArray(d.tableData)
                                ? d.tableData
                                : [];

                              const textoUno = d.textoUno ?? d.texto_uno ?? '';

                              const toNum = (v) => {
                                if (v === undefined || v === null || v === '') return 0;
                                const s = String(v).replace(/[^\d.-]/g, '');
                                return s === '' ? 0 : Number(s);
                              };

                              const totalHogares = datos.reduce((acc, r) => acc + toNum(r.totalHogares), 0);
                              const totalPersonas = datos.reduce((acc, r) => acc + toNum(r.totalPersonas), 0);

                              const pct = (val, tot) => {
                                if (tot === 0) return '-';
                                return ((toNum(val) / tot) * 100).toFixed(1) + '%';
                              };

                              return (
                                <div>
                                  {textoUno && (
                                    <div className="form-group">
                                      <label>Texto descriptivo</label>
                                      <textarea
                                        className="form-control"
                                        rows={3}
                                        {...register('datosPaginaDiecisiete.textoUno')}
                                        defaultValue={textoUno}
                                      />
                                    </div>
                                  )}

                                  <h6>Factores de Incidencia</h6>
                                  <div style={{ marginBottom: 8 }}>
                                    <button 
                                      type="button" 
                                      className="btn btn-success"
                                      onClick={async () => { await downloadToExcel(datos, 'FactoresDeIncidencia.xlsx')}}>A Excel</button>
                                  </div>
                                  {datos.length ? (
                                    <div style={{ overflowX: 'auto' }}>
                                      <table className="table table-sm table-striped">
                                        <thead>
                                          <tr>
                                            <th>Categoría</th>
                                            <th>Factor de Incidencia</th>
                                            <th style={{ textAlign: 'right' }}>Hogares</th>
                                            <th style={{ textAlign: 'right' }}>%</th>
                                            <th style={{ textAlign: 'right' }}>Personas</th>
                                            <th style={{ textAlign: 'right' }}>%</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {datos
                                            .slice()
                                            .sort((a, b) => toNum(b.totalHogares) - toNum(a.totalHogares))
                                            .map((r, i) => (
                                              <tr key={r.id ?? `factor-${i}`}>
                                                <td>{String(r.categoria ?? '-')}</td>
                                                <td>{String(r.hecho ?? '-')}</td>
                                                <td style={{ textAlign: 'right' }}>
                                                  {toNum(r.totalHogares) === 0 ? '-' : toNum(r.totalHogares).toLocaleString()}
                                                </td>
                                                <td style={{ textAlign: 'right' }}>{pct(r.totalHogares, totalHogares)}</td>
                                                <td style={{ textAlign: 'right' }}>
                                                  {toNum(r.totalPersonas) === 0 ? '-' : toNum(r.totalPersonas).toLocaleString()}
                                                </td>
                                                <td style={{ textAlign: 'right' }}>{pct(r.totalPersonas, totalPersonas)}</td>
                                              </tr>
                                            ))}
                                          <tr>
                                            <td colSpan={2}><strong>Total</strong></td>
                                            <td style={{ textAlign: 'right' }}><strong>{totalHogares.toLocaleString()}</strong></td>
                                            <td />
                                            <td style={{ textAlign: 'right' }}><strong>{totalPersonas.toLocaleString()}</strong></td>
                                            <td />
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  ) : (
                                    <p>No hay datos de factores de incidencia.</p>
                                  )}
                                </div>
                              );
                            })()}
                          </CardBody>
                        </Card>}
                        {getValues('fechaMesActual') && <Card style={{ marginTop: 20 }}>
                          <CardHeader>
                            <h3 className="card-title">Datos pagina dieciocho reporte</h3>
                          </CardHeader>
                          <CardBody>
                            {(() => {
                              const d = watch('datosPaginaDieciocho') || {};

                              const subTitle = d.subTitle ?? d.sub_title ?? '';
                              const texto = d.texto ?? '';
                              const recomendaciones = d.recomendaciones ?? '';

                              return (
                                <div>
                                  <div className="form-group">
                                    <label>Subtítulo</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register('datosPaginaDieciocho.subTitle')}
                                      defaultValue={subTitle}
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Texto (Riesgo y descripción)</label>
                                    <textarea
                                      className="form-control"
                                      rows={8}
                                      {...register('datosPaginaDieciocho.texto')}
                                      defaultValue={texto}
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>Recomendaciones (Acciones requeridas)</label>
                                    <textarea
                                      className="form-control"
                                      rows={4}
                                      {...register('datosPaginaDieciocho.recomendaciones')}
                                      defaultValue={recomendaciones}
                                    />
                                  </div>
                                </div>
                              );
                            })()}
                          </CardBody>
                        </Card>}
                        {getValues('fechaMesActual') && <Card style={{ marginTop: 20 }}>
                          <CardHeader>
                            <h3 className="card-title">Datos pagina diecinueve reporte</h3>
                          </CardHeader>
                          <CardBody>
                            {(() => {
                              const d = watch('datosPaginaDiecinueve') || {};

                              const title = d.title ?? '';
                              const subTitle = d.subTitle ?? d.sub_title ?? '';
                              const data = Array.isArray(d.data) ? d.data : [];
                              return (
                                <div>
                                  <div className="form-group">
                                    <label>{title}</label>
                                  </div>
                                  <div className="form-group">
                                    <label>Subtítulo</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      {...register('datosPaginaDiecinueve.subTitle')}
                                      defaultValue={subTitle}
                                    />
                                  </div>
                                  {data.length ? (
                                    <div style={{ marginTop: 12 }}>
                                      {data.map((item, index) => (
                                        <div key={index} style={{ marginBottom: 20, padding: 16, backgroundColor: '#f9f9f9', borderRadius: 4, border: '1px solid #e0e0e0' }}>
                                          <div className="form-group">
                                            <label><strong>Item {index + 1} - Etiqueta</strong></label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              {...register(`datosPaginaDiecinueve.data.${index}.Label`)}
                                              defaultValue={item.Label || ''}
                                              placeholder="Ej: La población víctima presenta características..."
                                            />
                                          </div>
                                          
                                          {Array.isArray(item.texto) && item.texto.length > 0 ? (
                                            <div>
                                              <label><strong>Textos</strong></label>
                                              {item.texto.map((text, textIndex) => (
                                                <div key={textIndex} className="form-group" style={{ marginBottom: 10 }}>
                                                  <label style={{ fontSize: '0.9em', color: '#666' }}>Texto {textIndex + 1}</label>
                                                  <textarea
                                                    className="form-control"
                                                    rows={3}
                                                    {...register(`datosPaginaDiecinueve.data.${index}.texto.${textIndex}`)}
                                                    defaultValue={text || ''}
                                                    placeholder={`Descripción o detalle ${textIndex + 1}`}
                                                  />
                                                </div>
                                              ))}
                                            </div>
                                          ) : (
                                            <p className="text-muted">No hay textos disponibles.</p>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  ) : (
                                    <p className="text-muted">No hay datos disponibles.</p>
                                  )}
                                </div>
                              );
                            })()}
                          </CardBody>
                        </Card>}
                        {getValues('fechaMesActual') && <Card style={{ marginBottom: 20 }}>
                            <CardBody>
                                <button type="submit" className="btn btn-primary">
                                    Guardar Reporte
                                </button>
                            </CardBody>
                        </Card>}
                    </form>
                </div>
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}